export const getCookie = (name) => {
  if (typeof window === 'undefined') return null; // SSR check

  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    return parts.pop().split(';').shift();
  }
  return null;
};

export const parseDataFromCookie = (cookieName) => {
  try {
    const cookie = getCookie(cookieName);
    if (!cookie) return null;

    // If cookie is URL encoded, decode it first
    const decodedCookie = decodeURIComponent(cookie);
    return JSON.parse(decodedCookie);
  } catch (error) {
    console.error('Error parsing user from cookie:', error);
    return null;
  }
};